<template>
  <div id="the-collection">
    <b-container class="the-collection-container">
      <Header v-if="!spanish" title="The Collection" />
      <Header v-if="spanish" title="La Colección" />
      <p v-if="!spanish" class="description english">
        Each design features the colors of the respective flag of each home country
        but depicted as energy that “colors” the environment around each player in
        dynamic ways. Blending this cultural energy alongside the iconic elements
        of Wrigley Field, we see a fascinating juxtaposition of baseball history
        alongside young players who connect the game in profound ways to Mexico,
        the Dominican Republic and Venezuela.
        <br><br>
        Select your favorite poster or get all three to create a unique mural that
        celebrates the Chicago Cubs and Hispanic Heritage Month.
      </p>
      <div v-if="spanish" class="description spanish">
        Cada diseño incluye los colores de la bandera respectiva de cada país,
        pero representados como la energía que ""colorea"" el entorno alrededor
        de cada jugador de manera dinámica. Mezclando esta energía cultural con
        los elementos icónicos de Wrigley Field, vemos una fascinante aproximación
        de la historia del béisbol con jóvenes jugadores que conectan el juego de
        manera profunda con México, República Dominicana y Venezuela. 
        <br><br>
        Selecciona tu póster favorito o consigue los tres para crear un mural único
        que celebre a los Cachorros de Chicago y el Mes de la Herencia Hispana.
      </div>
      <div class="cards" v-if="!spanish">
        <ProductCard
          :productCardId="1"
          class="collection-card"
          :price="true"
          :productData="{
            title: `Orgullo Venezolano`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-01.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-01.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO VENEZOLANO
          </h5>
        </ProductCard>
        <ProductCard
          :productCardId="2"
          :price="true"
          class="collection-card"
          :productData="{
            title: `ORGULLO MEXICANO`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-02.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-02.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO<br> MEXICANO
          </h5>
        </ProductCard>
        <ProductCard
          :productCardId="3"
          :price="true"
          class="collection-card"
          :productData="{
            title: `ORGULLO DOMINICANO`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-03.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-03.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO DOMINICANO
          </h5>
        </ProductCard>
      </div>
      <div class="cards" v-if="spanish">
        <ProductCard
          :productCardId="1"
          :price="true"
          :spanish="'true'"
          class="collection-card"
          :productData="{
            title: `Orgullo Venezolano`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-01.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-01.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'VENDIDO',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO VENEZOLANO
          </h5>
        </ProductCard>
        <ProductCard
          :productCardId="2"
          :price="true"
          :spanish="'true'"
          class="collection-card"
          :productData="{
            title: `ORGULLO MEXICANO`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-02.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-02.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'VENDIDO',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO<br> MEXICANO
          </h5>
        </ProductCard>
        <ProductCard
          :productCardId="3"
          :price="true"
          :spanish="'true'"
          class="collection-card"
          :productData="{
            title: `ORGULLO DOMINICANO`,
            buyurl: 'https://www.ivyshop.net/pages/respect',
            images: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-03.jpg')
            ],
            highResImages: [
              require('@/assets/images/products/pablo/Pablo-Serrano-Poster-03.jpg')
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'VENDIDO',
            },
          }"
        >
          <h5 slot="product-title">
            ORGULLO DOMINICANO
          </h5>
        </ProductCard>
      </div>
      <div class="poster-description" v-if="!spanish">
        <h5>BUY ALL THREE POSTERS FOR $129.99</h5>
        <p>
          Specifications: 18" x 24"
          <br><br>
          Designed in collaboration with Chicago artist Pablo Serrano. Proceeds benefit the Latino Policy Forum.
        </p>
      </div>
      <div class="poster-description" v-else-if="spanish">
        <h5>COMPRE LOS TRES CARTELES POR $129.99</h5>
        <p>
          Especificaciones: 18 pulgadas de ancho; 24 pulgadas de alto.
          <br><br>
          Diseñado en colaboración con el artista de Chicago, Pablo Serrano. Procede a benecificio
          del Latino Policy Forum.
        </p>
      </div>
    </b-container>
    <div class="posters">
      <img src="@/assets/images/products/pablo/mural.jpg" />
    </div>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import ProductCard from "@/components/global/ProductCard";
import moment from "moment";

import { mapState } from "vuex";
export default {
  name: "TheCollection",
  props: ["spanish"],
  data() {
    return {
      moment,
      productAvailable: false,
    };
  },
  components: {
    Header,
    ProductCard,
  },
  computed: {
    ...mapState(["global"]),
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
#the-collection {
  padding-bottom: 100px;
  @media (max-width: $lg) {
    padding-bottom: 50px;
  }
  @media (max-width: $md) {
    padding-bottom: 0px;
  }
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-collection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .description {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    max-width: 852px;
    margin-top: 22px;
  }
  .cards {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;
    }
  }
  .collection-card {
    width: 318px;
    max-width: 32.2%;
    @media (max-width: $lg) {
      margin-bottom: 50px;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: $lg) {
      text-align: center;
    }
  }
  .poster-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 50px 0 100px 0;
    h5 {
      font-family: Poppins-Bold;
      font-size: 26px;
      color: #1a1a1a;
      letter-spacing: 0;
      text-align: center;
      line-height: 28px;
      margin: 16px;
    }
    p {
      text-align: center;
    }
  }
  .posters {
    width: 100%;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
